import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "content", "kind", "maxValue", "hasLeadingZeros", "hasChildren"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { kindMap } from './helper';
import { KINDS, addLeadingZeros } from '../helper';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
const DISPLAY_NAME = 'Badge';
const Root = styled.span.withConfig({
  displayName: "Badge__Root",
  componentId: "sc-jh3v05-0"
})(["height:12px;width:12px;border-radius:var(--border-radius-circle);font:var(--text-xs-bold);", ""], _ref => {
  let {
    $hasChildren
  } = _ref;
  return $hasChildren && css(["position:absolute;top:0;right:0;transform:translate(calc(100% + var(--size-spacing-02)),-50%);margin-left:var(--size-spacing-02);"]);
});
const Wrapper = styled.span.withConfig({
  displayName: "Badge__Wrapper",
  componentId: "sc-jh3v05-1"
})(["", " display:inline-flex;position:relative;width:max-content;svg + ", "{transform:translate(0,-50%);margin-left:0;}", " ", ""], ScopedCssBaseline, Root, _ref2 => {
  let {
    $content
  } = _ref2;
  return ($content || $content === 0) && css(["", "{top:50%;height:16px;width:auto;border-radius:var(--border-radius-pill);padding:0 var(--size-spacing-02);}svg + ", "{top:0;right:auto;left:50%;}"], Root, Root);
}, _ref3 => {
  let {
    $kind
  } = _ref3;
  const {
    background,
    color
  } = kindMap.get($kind);
  return css(["", "{color:", ";background-color:", ";}"], Root, color, background);
});
const Badge = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
      children,
      content,
      kind,
      maxValue,
      hasLeadingZeros
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded);
  const getFormattedText = () => {
    if (maxValue) {
      if (hasLeadingZeros) {
        return content > maxValue ? "".concat(maxValue, "+") : addLeadingZeros(content, maxValue.toString().length);
      }
      return content > maxValue ? "".concat(maxValue, "+") : content;
    }
    return content;
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, rest, {
    $content: content,
    $kind: kind,
    ref: ref
  }), children, /*#__PURE__*/React.createElement(Root, {
    $hasChildren: !!children
  }, getFormattedText()));
});
Badge.displayName = DISPLAY_NAME;
Badge.Style = Root;
Badge.WrapperStyle = Wrapper;
Badge.kinds = {
  success: KINDS.SUCCESS,
  default: KINDS.DEFAULT,
  danger: KINDS.DANGER
};
Badge.defaultProps = {
  content: null,
  kind: Badge.kinds.danger,
  maxValue: null,
  hasLeadingZeros: false
};
process.env.NODE_ENV !== "production" ? Badge.propTypes = {
  /**
   * Should be some string or element
   */
  children: PropTypes.node,
  /**
   * Sets the value of badge
   */
  content: PropTypes.number,
  /**
   * Sets the style kinds
   */
  kind: PropTypes.oneOf([Badge.kinds.success, Badge.kinds.default, Badge.kinds.danger]),
  /**
   * Sets the maximum value to be shown
   */
  maxValue: PropTypes.number,
  /**
   * Sets the badge with left zero
   */
  hasLeadingZeros: PropTypes.bool
} : void 0;
export default Badge;